"use client";

import { MyH2 } from "../atoms";
import { ContactForm } from "../pages/contact";
import contactImg from "../../assets/images/contact.jpg";
import classNames from "classnames";
import styles from "../../components/pages/homepage/styles.module.scss";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import axios, { AxiosError } from "axios";

const noNeedRoutes = ["/contact"];

export const BlockContact = () => {
  const [hide, setHide] = useState<boolean>(true);

  const pathname = usePathname() || "";

  useEffect(() => {
    const checkExec = async () => {
      try {
        await axios.get(pathname);
        setHide(false);
      } catch (e) {
        setHide((e as AxiosError)?.response?.status === 404);
      }
    };

    checkExec();
  }, [pathname]);

  return (
    <>
      {!noNeedRoutes.includes(pathname) && !hide && (
        <div className="py-[64px] my-container bg-background lg:py-[80px] 2xl:py-[120px] ">
          <div className="mx-[-30px] lg:mx-[-60px] xl:mx-0 px-[30px] lg:px-[60px] xl:px-0 py-[64px] lg:py-[120px] grid grid-cols-12 bg-background-white">
            <div
              className={classNames(
                styles.contact_block,
                "col-span-full xl:col-start-2 xl:col-end-12"
              )}
            >
              <MyH2>Une question ? Un projet ?</MyH2>
              <div className={styles.contact}>
                <ContactForm
                  inContactPage={false}
                  homePageClassName={{
                    container: styles.form_container,
                    form: styles.form,
                    image: styles.image,
                  }}
                  rightImage={contactImg}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
